import * as React from "react";
import { topCitiesView } from "./views/topCitiesView";
import { TopCitiesProps } from "./typings";

export const ProductTypeContext = React.createContext("");

const TopCities = (props: TopCitiesProps) => {
  const { flexComponent, context } = props;
  const { model } = flexComponent;
  const { view } = model;

  const View = topCitiesView[view];

  if (!View) {
    return null;
  }

  return <View flexComponent={flexComponent} context={context} />;
};

export default TopCities;
